import { localizeWithPath } from '../../nls.js';
const _moduleId = "vs/editor/common/standaloneStrings";
var AccessibilityHelpNLS;
( ((function(AccessibilityHelpNLS) {
    AccessibilityHelpNLS.accessibilityHelpTitle = ( localizeWithPath(_moduleId, 0, "Accessibility Help"));
    AccessibilityHelpNLS.openingDocs = ( localizeWithPath(_moduleId, 1, "Opening the Accessibility documentation page."));
    AccessibilityHelpNLS.readonlyDiffEditor = ( localizeWithPath(_moduleId, 2, "You are in a read-only pane of a diff editor."));
    AccessibilityHelpNLS.editableDiffEditor = ( localizeWithPath(_moduleId, 3, "You are in a pane of a diff editor."));
    AccessibilityHelpNLS.readonlyEditor = ( localizeWithPath(_moduleId, 4, "You are in a read-only code editor."));
    AccessibilityHelpNLS.editableEditor = ( localizeWithPath(_moduleId, 5, "You are in a code editor."));
    AccessibilityHelpNLS.changeConfigToOnMac = ( localizeWithPath(
        _moduleId,
        6,
        "Configure the application to be optimized for usage with a Screen Reader (Command+E)."
    ));
    AccessibilityHelpNLS.changeConfigToOnWinLinux = ( localizeWithPath(
        _moduleId,
        7,
        "Configure the application to be optimized for usage with a Screen Reader (Control+E)."
    ));
    AccessibilityHelpNLS.auto_on = ( localizeWithPath(
        _moduleId,
        8,
        "The application is configured to be optimized for usage with a Screen Reader."
    ));
    AccessibilityHelpNLS.auto_off = ( localizeWithPath(
        _moduleId,
        9,
        "The application is configured to never be optimized for usage with a Screen Reader."
    ));
    AccessibilityHelpNLS.screenReaderModeEnabled = ( localizeWithPath(_moduleId, 10, "Screen Reader Optimized Mode enabled."));
    AccessibilityHelpNLS.screenReaderModeDisabled = ( localizeWithPath(_moduleId, 11, "Screen Reader Optimized Mode disabled."));
    AccessibilityHelpNLS.tabFocusModeOnMsg = ( localizeWithPath(
        _moduleId,
        12,
        "Pressing Tab in the current editor will move focus to the next focusable element. Toggle this behavior {0}."
    ));
    AccessibilityHelpNLS.tabFocusModeOnMsgNoKb = ( localizeWithPath(
        _moduleId,
        13,
        "Pressing Tab in the current editor will move focus to the next focusable element. The command {0} is currently not triggerable by a keybinding."
    ));
    AccessibilityHelpNLS.stickScrollKb = ( localizeWithPath(
        _moduleId,
        14,
        "Focus Sticky Scroll ({0}) to focus the currently nested scopes."
    ));
    AccessibilityHelpNLS.stickScrollNoKb = ( localizeWithPath(
        _moduleId,
        15,
        "Focus Sticky Scroll to focus the currently nested scopes. It is currently not triggerable by a keybinding."
    ));
    AccessibilityHelpNLS.tabFocusModeOffMsg = ( localizeWithPath(
        _moduleId,
        16,
        "Pressing Tab in the current editor will insert the tab character. Toggle this behavior {0}."
    ));
    AccessibilityHelpNLS.tabFocusModeOffMsgNoKb = ( localizeWithPath(
        _moduleId,
        17,
        "Pressing Tab in the current editor will insert the tab character. The command {0} is currently not triggerable by a keybinding."
    ));
    AccessibilityHelpNLS.showAccessibilityHelpAction = ( localizeWithPath(_moduleId, 18, "Show Accessibility Help"));
    AccessibilityHelpNLS.listSignalSounds = ( localizeWithPath(
        _moduleId,
        19,
        "Run the command: List Signal Sounds for an overview of all sounds and their current status."
    ));
    AccessibilityHelpNLS.listAlerts = ( localizeWithPath(
        _moduleId,
        20,
        "Run the command: List Signal Announcements for an overview of announcements and their current status."
    ));
    AccessibilityHelpNLS.quickChat = ( localizeWithPath(_moduleId, 21, "Toggle quick chat ({0}) to open or close a chat session."));
    AccessibilityHelpNLS.quickChatNoKb = ( localizeWithPath(
        _moduleId,
        22,
        "Toggle quick chat is not currently triggerable by a keybinding."
    ));
    AccessibilityHelpNLS.startInlineChat = ( localizeWithPath(
        _moduleId,
        23,
        "Start inline chat ({0}) to create an in editor chat session."
    ));
    AccessibilityHelpNLS.startInlineChatNoKb = ( localizeWithPath(
        _moduleId,
        24,
        "The command: Start inline chat is not currentlyt riggerable by a keybinding."
    ));
})(AccessibilityHelpNLS || (AccessibilityHelpNLS = {}))));
var InspectTokensNLS;
( ((function(InspectTokensNLS) {
    InspectTokensNLS.inspectTokensAction = ( localizeWithPath(_moduleId, 25, "Developer: Inspect Tokens"));
})(InspectTokensNLS || (InspectTokensNLS = {}))));
var StandaloneCodeEditorNLS;
( ((function(StandaloneCodeEditorNLS) {
    StandaloneCodeEditorNLS.editorViewAccessibleLabel = ( localizeWithPath(_moduleId, 32, "Editor content"));
    StandaloneCodeEditorNLS.accessibilityHelpMessage = ( localizeWithPath(_moduleId, 33, "Press Alt+F1 for Accessibility Options."));
})(StandaloneCodeEditorNLS || (StandaloneCodeEditorNLS = {}))));
var ToggleHighContrastNLS;
( ((function(ToggleHighContrastNLS) {
    ToggleHighContrastNLS.toggleHighContrast = ( localizeWithPath(_moduleId, 34, "Toggle High Contrast Theme"));
})(ToggleHighContrastNLS || (ToggleHighContrastNLS = {}))));
var StandaloneServicesNLS;
( ((function(StandaloneServicesNLS) {
    StandaloneServicesNLS.bulkEditServiceSummary = ( localizeWithPath(_moduleId, 35, "Made {0} edits in {1} files"));
})(StandaloneServicesNLS || (StandaloneServicesNLS = {}))));
export { AccessibilityHelpNLS, InspectTokensNLS, StandaloneCodeEditorNLS, StandaloneServicesNLS, ToggleHighContrastNLS };
